import type { AppModule } from '@/shared/types';
import * as routes from '@/modules/interactive-experience/routes';

export const InteractiveExperienceModule: AppModule = {
  routes,
};
